import type { MobilityProjectDTO } from '@ui/shared/util-api';
import { MapItem } from '@ui/shared/util-map';

export class MobilityMapItem extends MapItem {
    public readonly categoryId: number;
    public readonly categoryLabel: string;
    public readonly guidingThemeId: number;
    public readonly guidingThemeLabel: string;
    public readonly transportationTypeId: number;
    public readonly transportationTypeLabel: string;
    public readonly description: string;
    public readonly imagePath: string;
    public readonly thumbnailPath: string;
    public readonly weblink: string;
    public readonly statusCode: string;

    constructor(mapItem: MobilityProjectDTO) {
        super(mapItem);

        this.categoryId = mapItem.category.id;
        this.categoryLabel = mapItem.category.name;
        this.guidingThemeId = mapItem.guiding_theme.id;
        this.guidingThemeLabel = mapItem.guiding_theme.name;
        this.transportationTypeId = mapItem.transportation_type.id;
        this.transportationTypeLabel = mapItem.transportation_type.name;
        this.description = mapItem.description ?? '';
        this.iconPath = mapItem.icon ?? '';
        this.iconLabel = this.categoryLabel ? `Projekt: ${ this.categoryLabel }` : '';
        this.imagePath = mapItem.image?.thumbs?.detail ?? mapItem.image?.image ?? '';
        this.thumbnailPath = mapItem.image?.thumbs?.preview ?? this.imagePath;
        this.weblink = mapItem.weblink ?? '';
        this.statusCode = mapItem.status;
    }
}
